@let claims = (claims$ | async); @let currentUser = (currentUser$ | async); @let homeUrl = (homeUrl$ | async);

<!-- Sidebar Layout -->
@if(emailVerified$ | async) {
<app-narrow-sidebar-layout>
  <!-- Logo -->
  <img
    src="assets/images/talenttrace-logo-short-white.png"
    alt="TalentTrace"
    app-narrow-sidebar-logo />
  <!-- NavList -->
  @if(claims?.admin) {
  <app-narrow-sidebar-nav-list>
    <a
      [routerLink]="homeUrl"
      icon="home"
      app-narrow-sidebar-nav-list-item>
      <ng-container i18n>Dashboard</ng-container>
    </a>
    <a
      [routerLink]="['/organizations']"
      icon="building-office"
      app-narrow-sidebar-nav-list-item>
      <ng-container i18n>Organizations</ng-container>
    </a>
    <a
      [routerLink]="'#TODO'"
      icon="user-group"
      app-narrow-sidebar-nav-list-item>
      <ng-container i18n>Candidates</ng-container>
    </a>
    <a
      [routerLink]="['/users']"
      icon="users"
      app-narrow-sidebar-nav-list-item>
      <ng-container i18n>Users</ng-container>
    </a>
  </app-narrow-sidebar-nav-list>
  } @else if (claims && claims.organizationAdmin && claims.organizationId) {
  <app-narrow-sidebar-nav-list>
    <a
      [routerLink]="homeUrl"
      icon="home"
      app-narrow-sidebar-nav-list-item>
      <ng-container i18n>Dashboard</ng-container>
    </a>
    <a
      [routerLink]="['/organizations', claims.organizationId, 'job-postings']"
      icon="briefcase"
      app-narrow-sidebar-nav-list-item>
      <ng-container i18n>Our jobs</ng-container>
    </a>
    <a
      [routerLink]="['/organizations', claims.organizationId, 'edit']"
      icon="building-office"
      app-narrow-sidebar-nav-list-item>
      <ng-container i18n>Our profile</ng-container>
    </a>
  </app-narrow-sidebar-nav-list>
  } @else if (claims?.candidate) {
  <app-narrow-sidebar-nav-list>
    <a
      [routerLink]="homeUrl"
      icon="home"
      app-narrow-sidebar-nav-list-item>
      <ng-container i18n>Dashboard</ng-container>
    </a>
    <a
      [routerLink]="currentUser ? ['/candidates', currentUser.ref.id, 'applications'] : null"
      icon="briefcase"
      app-narrow-sidebar-nav-list-item>
      <ng-container i18n>Your applications</ng-container>
    </a>
    <a
      [routerLink]="currentUser ? ['/candidates', currentUser.ref.id, 'edit'] : null"
      icon="user"
      app-narrow-sidebar-nav-list-item>
      <ng-container i18n>Your profile</ng-container>
    </a>
  </app-narrow-sidebar-nav-list>
  }
  <!-- Search -->
  <input
    [appAutocomplete]="search.autocomplete"
    app-narrow-sidebar-search
    placeholder="Search"
    placeholder-i18n
    aria-label="Search" />
  <!-- Navigation Autocomplete Search -->
  <app-main-navigation-search
    #search
    [currentUser]="currentUser"
    [organizationId]="claims?.organizationId ?? null">
  </app-main-navigation-search>
  <!-- Profile -->
  <app-narrow-sidebar-profile>
    <img
      [src]="currentUser?.data?.photoRef | imageResolution : '128x128' : 'user' | async"
      alt="User Profile"
      app-narrow-sidebar-profile-image />
    <a
      [routerLink]="currentUser ? ['/users', currentUser.ref.id, 'edit'] : null"
      app-narrow-sidebar-profile-menu-item>
      <ng-container i18n>Your profile</ng-container>
    </a>
    <a
      [routerLink]="['/sign-out']"
      app-narrow-sidebar-profile-menu-item>
      <ng-container i18n>Sign out</ng-container>
    </a>
    {{ currentUser | name : { mode: 'fullName' } }}
  </app-narrow-sidebar-profile>
  <!-- Router -->
  <ng-container [ngTemplateOutlet]="routerTpl"></ng-container>
</app-narrow-sidebar-layout>
} @else {
<ng-container [ngTemplateOutlet]="routerTpl"></ng-container>
}

<!-- Router Outlet Template -->
<ng-template #routerTpl>
  <ng-content></ng-content>
</ng-template>
